module.exports = "/images/sellers-shield-gold.svg?cad86ddb1595058cfc754b7e398c33f0";